
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import VideoSection from './components/VideoSection';
import FeaturesSection from './components/FeaturesSection';
import DevicesSection from './components/DevicesSection';
import PricingSection from './components/PricingSection';
import TrialSection from './components/TrialSection';
import StepsSection from './components/StepsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <VideoSection />
        <DevicesSection />
        <FeaturesSection />
        <PricingSection />
        <TrialSection />
        <StepsSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
